<bb-transaction-signing-error *ngIf="errorValue; else displayForm"
                              [error]="errorValue"
                              (close)="acceptError.emit($event)">
</bb-transaction-signing-error>

<ng-template #displayForm>

  <div *ngIf="!sent"
       class="bn-transaction-signing-widget__block">

    <div class="bn-transaction-signing-widget__content">

      <div class="bn-transaction-signing-widget__content__inner">
        <p class="mb-0"
           i18n="@@bb-sms-otp-signing.confirm-identity">For your security, we need to confirm your identity.</p>
        <p i18n="@@bb-sms-otp-signing.you-will-receive">You will receive your code to the following phone number:</p>

        <div><b>{{ data.phoneNumber }}</b></div>
      </div>

    </div>


    <hr />
    <div class="bb-button-bar">
      <button bbButton
              data-role="ts-sms-otp-complete"
              class="bb-button-bar__button"
              color="primary"
              i18n="@@bb-oob-select-device-signing.complete"
              (click)="sent = true">
        Continue
      </button>
      <button bbButton
              data-role="ts-sms-otp-cancel"
              class="bb-button-bar__button"
              color="secondary"
              i18n="@@contact-manager.banesco-form.cancel"
              (click)="cancel.emit()">
        Cancel
      </button>
    </div>
  </div>

  <ng-container *ngIf="sent">
    <!-- <div class="bb-block bb-block--sm"
         i18n="Instruction for sms otp signing@@bb-sms-otp-signing.instruction">
         SMS message sent to {{ data.phoneNumber }}
    </div> -->
    <div class="bb-block bb-block--lg">
      <!-- <ng-container *ngIf="data.remainingOtpRequests !== 0; else displayNoRemainingRequests">
        <ng-container *ngIf="(timeUntilResend$ | async) as time; else displayResendButton">
          <span class="bb-subtitle bb-text-support bb-block bb-block--sm"
                i18n="Time before resend@@bb-sms-otp-signing.resend.time-before">
            Next resend available in {{ time }} {time, plural, =1 {second} other {seconds}}
          </span>
          <bb-progressbar-ui height="0.5rem"
                             [value]="data.nextOtpTime - time"
                             [max]="data.nextOtpTime">
          </bb-progressbar-ui>
        </ng-container>
        <ng-template #displayResendButton>
          <button bbButton
                  data-role="ts-sms-otp-resend"
                  color="secondary"
                  buttonSize="sm"
                  i18n="Resend SMS OTP button@@bb-sms-otp-signing.resend"
                  (click)="resend.emit()">
            Resend message
          </button>
        </ng-template>
      </ng-container> -->
      <!-- <ng-template #displayNoRemainingRequests>
        <span data-role="ts-sms-otp-no-resend"
              class="bb-subtitle bb-text-danger"
              i18n="No otp resend attempts remaining@@bb-sms-otp-signing.no-resend">
          You have no SMS resend attempts left. <br>
          Please enter the correct OTP code or cancel this transaction.
        </span>
      </ng-template> -->
    </div>

    <form [formGroup]="form"
          (submit)="onComplete()"
          class="bb-block">

      <div class="bn-transaction-signing-widget__content">
        <div class="bn-transaction-signing-widget__content__inner">
          <div class="form-group bn-transaction-signing-widget__block">
            <bb-input-text-ui data-role="ts-sms-otp-field"
                              class="bb-form-field"
                              formControlName="otp"
                              i18n-label="Aria label for otp field input@@bb-sms-otp-signing.label"
                              label="Enter your verification code"
                              [maxLength]="data.expectedOtpLength"
                              [minLength]="data.expectedOtpLength">
            </bb-input-text-ui>


            <bb-alert-ui *ngIf="displayMissingAlert"
                         data-role="ts-sms-otp-missing-alert"
                         i18n-title="No value alert title for sms otp signing@@bb-sms-otp-signing.alert.missing.title"
                         title="No value entered">
              <span i18n="No value alert message for sms otp signing@@bb-sms-otp-signing.alert.missing.message">
                Please enter the value displayed on your device.
              </span>
            </bb-alert-ui>
            <bb-alert-ui *ngIf="displayIncorrectAlert"
                         data-role="ts-sms-otp-incorrect-alert"
                         i18n-title="Incorrect attempts alert title for sms otp signing@@bb-sms-otp-signing.alert.incorrect.title">
              <span i18n="@bb-sms-otp-signing.alert.incorrect.message-banesco">
                Incorrect code, please try again.
              </span>
            </bb-alert-ui>
            <bb-alert-ui *ngIf="displayRemainingAlert"
                         data-role="ts-sms-otp-remaining-alert"
                         i18n-title="Remaining attempts alert title for sms otp signing@@bb-sms-otp-signing.alert.remaining.title">
              <span
                    i18n="Remaining attempts alert message for sms otp signing@@bb-sms-otp-signing.alert.remaining.message">
                Incorrect code, please try again. <br>
                You have {{data.remainingAuthenticationAttempts}} other {data.remainingAuthenticationAttempts, plural,
                =1
                {attempt} other {attempts}} remaining.
              </span>
            </bb-alert-ui>
            <bb-alert-ui *ngIf="displayResendAlert"
                         data-role="ts-sms-otp-resend-alert"
                         modifier="info"
                         i18n-title="Message resend alert title for sms otp signing@@bb-sms-otp-signing.alert.resend.title">
              <span i18n="Message resend alert message for sms otp signing@@bb-sms-otp-signing.alert.resend.message">
                The SMS message has been successfully sent. <br>
                You have
                {data.remainingOtpRequests, plural, =0 {no} other {{{data.remainingOtpRequests}} SMS}} resend
                {data.remainingOtpRequests, plural, =1 {attempt} other {attempts}}
                left.
              </span>
            </bb-alert-ui>

          </div>

          <p>
            <span i18n="@@bb-sms-otp-signing.did-not-receive-code">If you haven't received the text message, try again
              by
              clicking
            </span>
            <a i18n="@@bb-sms-otp-signing.resend"
               class="bn-transaction-signing-widget__link"
               (click)="resend.emit()">Resend</a>
            <span i18n="@@bb-sms-otp-signing.contact-us-at">
              or please contact us at:
            </span>
          </p>
          <ul>
            <li> <span i18n="@@bb-sms-otp-signing.main">Main</span> <b>829-893-8200</b></li>
            <li><span i18n="@@bb-sms-otp-signing.dominican-republic-number">Dominican Republic toll free</span>
              <b>1-809-200-1101</b></li>
            <li> <span i18n="@@bb-sms-otp-signing.whatsapp">Whatsapp</span> <b>829-647-8100</b></li>
          </ul>
        </div>
      </div>


      <hr>

      <div class="bb-button-bar">
        <button bbButton
                data-role="ts-sms-otp-complete"
                class="bb-button-bar__button"
                color="primary"
                type="submit"
                i18n="Complete button@@bb-sms-otp-signing.complete">
          Complete
        </button>
        <button bbButton
                data-role="ts-sms-otp-cancel"
                class="bb-button-bar__button"
                color="secondary"
                (click)="cancel.emit()"
                i18n="Cancel button@@bb-sms-otp-signing.cancel">
          Cancel
        </button>
      </div>
    </form>
  </ng-container>
</ng-template>
